import { z } from "zod";

export const createUserSchema = z.object({
  nome: z.string().min(1, "Nome é obrigatório"),
  email: z.string().email("E-mail inválido"),
  telefone: z
    .string()
    .regex(/^\d{10,11}$/, "Telefone deve ter 10 ou 11 dígitos"),
  cpf: z.string().regex(/^\d{11}$/, "CPF deve ter 11 dígitos"),
  dataNascimento: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Data deve estar no formato YYYY-MM-DD"),
  codigoIndicacao: z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z0-9]{8}$/, "Código de indicação deve ter 8 caracteres")
    .optional(),
});

export const updateUserSchema = z.object({
  nome: z.string().min(1, "Nome é obrigatório").optional(),
  email: z.string().email("E-mail inválido").optional(),
  telefone: z
    .string()
    .regex(/^\d{10,11}$/, "Telefone deve ter 10 ou 11 dígitos")
    .optional(),
  cpf: z
    .string()
    .regex(/^\d{11}$/, "CPF deve ter 11 dígitos")
    .optional(),
  dataNascimento: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "Data deve estar no formato YYYY-MM-DD")
    .optional(),
});

export const userResponseSchema = z.object({
  id: z.number(),
  nome: z.string(),
  email: z.string(),
  telefone: z.string(),
  telefoneVerificado: z.boolean(),
  emailVerificado: z.boolean(),
  cpf: z.string(),
  dataNascimento: z.string(),
  codigoIndicacao: z.string().nullable().optional(),
  googleId: z.string().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type CreateUserDto = z.infer<typeof createUserSchema>;
export type UpdateUserDto = z.infer<typeof updateUserSchema>;
export type UserResponseDto = z.infer<typeof userResponseSchema>;
